import { auth } from '../authConfig';

export const getAccessToken = async () => {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('No active session. Please sign in.');
  }
  // Always get fresh token — Firebase auto-refreshes if expired
  const token = await user.getIdToken();
  return token;
};